import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const Layout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  gap: 8px;

  > .display-controls {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  > .time-controls {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: end;
  }
`;

export const Badge = styled.div`
  background-color: var(
    --section-color-neutral-300-background-color,
    var(--color-neutral-300)
  );
  color: var(--section-slate-color, var(--slate));
  font-size: 12px;
  line-height: 24px;
  height: 24px;
  padding: 0 8px;
  ${semiBoldAlias()};
  border-radius: 2px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
